import { Editor } from "@tinymce/tinymce-react";
import React from "react";
import { useStorage } from "reactfire";

interface IProps {
    initialValue: string;
    onEditorChange(content: any, editor: any): void;
}

const TextEditor = (props: IProps) => {
    const storage = useStorage().ref();

    return (
        <Editor
            value={props.initialValue}
            apiKey={"t5wauipzy7x1msgvu2y1n2x4fg9vdd3nzbumusv71li0ys00"}
            init={{
                setup: function(editor: any) {},
                images_upload_handler: async (
                    blobInfo: any,
                    success: Function,
                    failure: Function
                ) => {
                    const file = blobInfo.blob();
                    storage
                        .child(`editor/${blobInfo.filename()}`)
                        .put(file)
                        .then((snapshot) => {
                            snapshot.ref
                                .getDownloadURL()
                                .then((url) => {
                                    success(url);
                                })
                                .catch((reson) => {
                                    failure(reson);
                                });
                        })
                        .catch((reson) => {
                            failure(reson);
                        });
                },
                height: 350,
                width: "100%",
                plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                ],
                image_uploadtab: true,
                image_description: false,
                image_dimensions: true,
                paste_data_images: true,
                automatic_uploads: true,
                mobile: {
                    menubar: false,
                    object_resizing: true,
                    resize: true,
                    imagetools_toolbar:
                        "rotateleft rotateright | flipv fliph imageoptions",
                    toolbar1:
                        "undo redo | bold italic forecolor backcolor | formatselect | alignleft aligncenter alignright alignjustify | help ",
                    toolbar2:
                        "fullscreen | link image table | bullist numlist outdent indent | removeformat",
                },
                menubar: true,
                object_resizing: true,
                resize_img_proportional: true,
                imagetools_toolbar:
                    "rotateleft rotateright | flipv fliph | editimage imageoptions",
                toolbar1:
                    "undo redo | bold italic forecolor backcolor | formatselect | alignleft aligncenter alignright alignjustify | help ",
                toolbar2:
                    "link image table | bullist numlist outdent indent | removeformat",
            }}
            onEditorChange={props.onEditorChange}
        />
    );
};

export default TextEditor;
